import React, {useEffect, useRef, useState} from 'react';
import {useField} from '@unform/core';
import {SketchPicker} from 'react-color';
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from 'reactstrap';
import styled from "styled-components";


const DropdownStyled = styled(Dropdown)`

.dropdown-toggle {
    white-space: nowrap;
    width: 100%;
    background-color: ${(props) => props.color};
}

.dropdown-toggle::after {
    position: relative;
    float: right;
    top: 10px;
}`

const ReactColor = ({name, type, onChangeComplete, ...rest}) => {

    const {fieldName, defaultValue, registerField, error} = useField(name);
    const [color, setColor] = useState();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen(prevState => !prevState);

    const colorRef = useRef(null)

    useEffect(() => {
        registerField({
            name: fieldName,
            ref: colorRef,
            getValue: ref => {
                if(color){
                    return ref.current.state[type]
                }
                return "";
            },
        })
    }, [fieldName, registerField, color])

    useEffect(() => {
        if(defaultValue){
            setColor(defaultValue)
        }
    }, [defaultValue])

    const onChangeCompleteHandler = (evt) => {

        setColor(evt[type]);

        if(onChangeComplete){
            onChangeComplete(evt);
        }
    }

    return (
        <>
            <DropdownStyled isOpen={dropdownOpen} toggle={toggle} color={color}>
                <DropdownToggle caret>
                    { color ? color : `Select the color` }
                </DropdownToggle>
                <DropdownMenu>
                    <DropdownItem>
                        <SketchPicker
                            ref={colorRef}
                            color={color}
                            onChangeComplete={onChangeCompleteHandler}
                            {...rest}
                        />
                    </DropdownItem>
                </DropdownMenu>
            </DropdownStyled>

            {error && <span className="error">{error}</span>}
        </>
    )
}

ReactColor.defaultProps = {
    type: 'hex'
};

export {
    ReactColor
}
